module.exports = __webpack_public_path__ + "static/media/sequence-monitoring.97320a9f.svg";